import { render } from "./indexeleventestimonial.vue?vue&type=template&id=3bf4e0b2"
import script from "./indexeleventestimonial.vue?vue&type=script&lang=js"
export * from "./indexeleventestimonial.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__